import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { ArrowLeft, Loader2, Mail } from "lucide-react";
import AuthShell from "../components/AuthShell";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { await api.authForgot(email.trim()); } catch { /* generic response */ }
    setSent(true); setLoading(false);
  };

  return (
    <AuthShell dataTestId="forgot-page" title="Mot de passe oublié" subtitle="Nous vous enverrons un lien de réinitialisation valable 1 heure.">
      {sent ? (
        <div className="rounded-md bg-[#E4F4EA] border border-[#C0E1CC] p-4 text-[13.5px] text-[#1B5C39]" data-testid="forgot-sent">
          <Mail className="w-4 h-4 inline mr-1" />
          Si cette adresse est enregistrée, un lien de réinitialisation vient d'être envoyé. Vérifiez votre boîte de réception (et les spams).
        </div>
      ) : (
        <form onSubmit={onSubmit} className="space-y-4" data-testid="forgot-form">
          <div>
            <label className="block text-[12px] font-semibold text-[#111111] mb-1.5">Adresse e-mail</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              data-testid="forgot-email"
              className="w-full h-11 px-3 rounded-md border border-[#CDD7E3] bg-white text-[14px] focus:outline-none focus:ring-2 focus:ring-[#2878FF]/25 focus:border-[#2878FF]" />
          </div>
          <button type="submit" disabled={loading || !email} data-testid="forgot-submit"
            className="w-full h-11 rounded-md text-[#111111] text-[14px] font-semibold inline-flex items-center justify-center gap-2 disabled:opacity-60"
            style={{ background: "#FF9F1C" }}>
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Mail className="w-4 h-4" />}
            Envoyer le lien
          </button>
        </form>
      )}
      <Link to="/connexion" className="mt-6 inline-flex items-center gap-1 text-[13px] text-[#1769E0] hover:text-[#0B1F33] font-medium" data-testid="back-to-login">
        <ArrowLeft className="w-3.5 h-3.5" /> Retour à la connexion
      </Link>
    </AuthShell>
  );
}
